import { ensureElement } from '../utils/utils';
import { Form } from './common/Form';
export class Order extends Form {
    constructor(container, events) {
        super(container, events);
        this.buttonCash = ensureElement('.button_alt[name=cash]', container);
        this.buttonCard = ensureElement('.button_alt[name=card]', container);
        this.buttonCard.addEventListener('click', () => {
            this.onInputChange('payment', 'card');
        });
        this.buttonCash.addEventListener('click', () => {
            this.onInputChange('payment', 'cash');
        });
    }
    set payment(value) {
        this.buttonCash.classList.toggle('button_alt-active', this.buttonCash.name === value);
        this.buttonCard.classList.toggle('button_alt-active', this.buttonCard.name === value);
    }
    disableButtons() {
        this.buttonCash.disabled = true;
        this.buttonCard.disabled = true;
    }
    set address(value) {
        this.container.elements.namedItem('address').value =
            value;
    }
}
export class Contacts extends Form {
    constructor(container, events) {
        super(container, events);
    }
    set phone(value) {
        this.container.elements.namedItem('phone').value =
            value;
    }
    set email(value) {
        this.container.elements.namedItem('email').value =
            value;
    }
}
